module.exports = __webpack_public_path__ + "88310281774022743e145b4a5582168c.pdf";